/** @format */

import React, { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { create } from 'jss';
import rtl from 'jss-rtl';
import MomentUtils from '@date-io/moment';
import { SnackbarProvider } from 'notistack';
import { jssPreset, StylesProvider, ThemeProvider } from '@material-ui/core';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import ScrollReset from 'src/components/ScrollReset';
import useSettings from 'src/hooks/useSettings';
import { createContiTheme } from 'src/theme';
import routes, { renderRoutes } from 'src/routes';

const jss = create({ plugins: [...jssPreset().plugins, rtl()] });

const App = () => {
  const { settings } = useSettings();

  const theme = createContiTheme({
    direction: settings.direction,
    responsiveFontSizes: settings.responsiveFontSizes,
    theme: settings.theme
  });

  /**
   * If the url contains a language parameter, remove it and store the chosen language in the dataLayer.
   */
  useEffect(() => {
    const url = new URL(window.location.href);
    if (url.searchParams.has('language') && window.trackDataLayer) {
      const lang = url.searchParams.get('language');
      window.trackDataLayer('language_changed', { language: lang });
      url.searchParams.delete('language');
      const newUrl = url.pathname + url.search + url.hash;
      window.history.replaceState(null, document.title, newUrl);
    }
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <StylesProvider jss={jss}>
        <MuiPickersUtilsProvider utils={MomentUtils}>
          <SnackbarProvider
            dense
            maxSnack={3}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right'
            }}>
            <BrowserRouter>
              <ScrollReset />
              {renderRoutes(routes)}
            </BrowserRouter>
          </SnackbarProvider>
        </MuiPickersUtilsProvider>
      </StylesProvider>
    </ThemeProvider>
  );
};

export default App;
